/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react';
import PropTypes from 'prop-types';

import SlideShow from './SlideShow';
import { useAssetImages } from '../../../hooks';

export default function SlideShowWithFetch({
    assetId,
    campsiteId,
    tourId,
    ...rest
}) {
    const { galleryImages, status } = useAssetImages({ assetId, campsiteId, tourId });
    return (
        <SlideShow
            images={galleryImages}
            status={status}
            {...rest} />
    );
}

SlideShowWithFetch.propTypes = {
    /** The id of the campground/permit/ticket facility/gateway/POI that the
     * api will use to fetch the images.
     * Do not use the images prop if using this prop. */
    assetId: PropTypes.string,

    /** The id of the campsite that the api will use to fetch the images
     * Do not use the images if using this prop.
    */
    campsiteId: PropTypes.string,

    /** The tour id the api will use to fetch the images
     * Do not use the images if using this prop.
    */
    tourId: PropTypes.string
};
